module.exports = __webpack_public_path__ + "static/img/order-management.e69597e.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/order-management.png
// module id = R/64
// module chunks = 1